// PAGE
import Home from './components/Home.vue';
import Details from './components/home/PageDetails.vue';
import Tarot from './components/pages/Tarot.vue';
import Numerology from './components/pages/Numerology.vue';
import Workshops from './components/pages/Workshops.vue';
import Energy from './components/pages/Energy.vue';

//ADMIN
import AdminCardsTarot from './components/admin/pages/cardsTarot.vue';
import AdminDashboard from './components/admin/pages/dashboard.vue';
import AdminNumerology from './components/admin/pages/numerology.vue';
import AdminCookies from './components/admin/pages/cookies.vue';
import AdminAbout from './components/admin/pages/about.vue';
import AdminContact from './components/admin/pages/contact.vue';
import AdminGallery from './components/admin/pages/gallery.vue';
import AdminPage from './components/admin/pages/page.vue';

// ERROR
import PageNotFound from './components/pages/PageNotFound';

export const routes = [
    // PAGE
    { path: '/', component: Home, name: "home" },
    { path: '/:type/details/:id', component: Details, name: "details" },
    { path: '/numerology', component: Numerology, name: "numberology" },
    { path: '/tarot', component: Tarot, name: "tarot" },
    { path: '/energy', component: Energy, name: "energy" },
    { path: '/workshops', component: Workshops, name: "workshops" },

    // ADMIN
    { path: '/home', component: AdminDashboard, name: "home-admin"},
    { path: '/home/cards-tarot', component: AdminCardsTarot, name: "home-cards-tarot"},
    { path: '/home/numerology', component: AdminNumerology, name: "home-numberology"},
    { path: '/home/cookies', component: AdminCookies, name: "home-cookies"},
    { path: '/home/about', component: AdminAbout, name: "home-about"},
    { path: '/home/contact', component: AdminContact, name: "home-contact"},
    { path: '/home/gallery', component: AdminGallery, name: "home-gallery"},

    // Admin - edit page
    { path: '/home/page/:page', component: AdminPage, name: "home-page"},

    // NOT FOUND
    { path: "*", component: PageNotFound, name: "not-found" }
]
